<template>
  <div class="w-3/4 mx-auto">
    <h1 class="text-xl mt-20 py-3">
      {{ $t('student.teachers') }}
    </h1>
    <div class="flex flex-col w-full items-start mt-8
      divide-y-2 divide-grey-academy-150">
      <round-photo-and-name
        v-for="teacher in teachers"
        :key="teacher.id"
        class="py-3 w-full"
        :person="teacher"
        containerClass="flex items-center"
        textClass="text-lg pl-6"
        :isTeacher="true" />

    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import StreamFunctionsMixin from '@/mixins/StreamFunctionsMixin';
import RoundPhotoAndName from './graphics/RoundPhotoAndName.vue';

export default {
  components: { RoundPhotoAndName },

  data() {
    return {
      teachers: [],
    };
  },

  created() {
    this.getTeachers();
  },

  computed: {
    ...mapGetters({
      user: 'auth/user',
    }),
  },

  mixins: [StreamFunctionsMixin],

  methods: {
    getTeachers() {
      axios.get(`/api/students/${this.$route.params.slug}/teachers`).then(({ data }) => {
        this.teachers = data;
      }).catch((error) => {
        console.log(error);
      });
    },
  },
};
</script>
